<template>
    <div class="lt">
        <div class="lt-bottom" v-if="defaultdata && defaultdata.length">
            <div class="lt-item-content">
                <div class="lt-bt-item" v-for="(item, index) in defaultdata.slice(0, 4)" :key="index">
                    <div class="item-top">
                        <div class="num">{{ item.value2 }}</div>
                        <div class="unit">{{ item.value3 }}</div>
                    </div>
                    <div class="title">{{ item.value1 }}</div>
                    <!-- <div class="lt-item-title ellipsis" style="width:100px;" :title="item.value1">
          {{ item.value1 }}
      </div> -->
                </div>
                <div class="it-content-bg"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";

export default {
    name: "template.scope72",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            //此页面的value2数据需要做限制，defaultdata需要做限制，最多展示4个
            title: "scope7-【组件】图文-4组数据-完成",
            defaultdata: [
                { value1: "文本一", value2: "24", value3: "单位" },
                { value1: "文本二", value2: "6", value3: "单位" },
                { value1: "文本三", value2: "14", value3: "单位" },
                { value1: "文本四", value2: "4", value3: "单位" },
                // { value1: "数据5", value2: "000", value3: "单位" },
                // { value1: "数据6", value2: "000", value3: "单位" },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
                { name: "单位", key: "value3" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
        };
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n.slice(0, 6);
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
    },
    methods: {
        ...methods,
    },
    mounted() {
        this.setData()
    },
};
</script>

<style scoped lang="scss">
@font-face {
    font-family: "Benmo-Ziyu";
    src: url("@/assets/fonts/Benmo-Ziyu.woff2");
}

.lt {
    width: 435px;
    height: 240px;
    display: flex;
    padding: 10px 0;
    position: relative;
    overflow: hidden;
    // pointer-events: none !important;
    // user-select: none!important;; /* 禁止文本和图片被选中 */
}

.lt-bottom {
    height: 240px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.it-content-bg {
    width: 170px;
    height: 170px;
    background: url("@/assets/temimg5/tuwen4-main.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}

.lt-item-content {
    position: relative;
    width: 420px;
    height: 226px;
    background: url("@/assets/temimg5/tuwen4-bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    /* 使用 flexbox 布局 */
    align-items: center;
    /* 垂直居中 */
    justify-content: center;
    /* 水平居中 */
}

.lt-bt-item {
    position: absolute;
    z-index: 5;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.lt-bt-item:nth-child(1) {
    top: 27px;
    left: 20px;
    align-items: flex-start;

    .title {
        position: absolute;
        top: 36px;
        left: 0px;
        text-align: left;
    }

    .item-top {
        flex-direction: row;
        justify-content: flex-start;
    }

    .unit {
        margin-left: 5px;
    }
}

.lt-bt-item:nth-child(2) {
    top: 27px;
    right: 20px;
    align-items: flex-end;

    .title {
        position: absolute;
        top: 36px;
        right: 0px;
        text-align: right;
    }

    .item-top {
        flex-direction: row-reverse;
        justify-content: flex-start;
    }

    .unit {
        margin-right: 5px;
    }
}

.lt-bt-item:nth-child(3) {
    bottom: 27px;
    left: 20px;
    align-items: flex-start;

    .title {
        position: absolute;
        top: -36px;
        left: 0px;
        text-align: left;
    }

    .item-top {
        flex-direction: row;
        justify-content: flex-start;
    }

    .unit {
        margin-left: 5px;
    }
}

.lt-bt-item:nth-child(4) {
    bottom: 27px;
    right: 20px;
    align-items: flex-end;

    .item-top {
        flex-direction: row-reverse;
        justify-content: flex-start;
    }

    .title {
        position: absolute;
        top: -36px;
        right: 0px;
        text-align: right;
    }

    .unit {
        margin-right: 5px;
    }
}

.item-top {
    display: flex;
    align-items: center;
}

.num {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 22px;
    color: #d2f2fe;
    line-height: 14px;
}

.unit {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #5e87b3;
    line-height: 14px;
    height: 14px;
    min-width: 30px;
    max-width: 50px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #a7d6fd;
    line-height: 16px;
    min-width: 80px;
    max-width: 80px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>